<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/provisioningDevice" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.EditHardwarePlan") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.ProvisioningSystem")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ProvisioningSystem')"
                >
                  <v-select
                    label="item"
                    v-model="hardwareSystem"
                    :options="proSystemList"
                    @input="selectedHardware(hardwareSystem)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.ItemClass")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.ItemClass')"
                >
                  <v-select
                    label="item"
                    v-model="itemClass"
                    :options="itemClassList"
                    @input="selectedItemClass(itemClass)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateHardwarePlan"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "" },
        {
          name: this.$t("system.label.ProvisioningDevice"),
          to: "/provisioningDevice",
        },
        {
          name: this.$t("system.label.EditHardwarePlan"),
          to: "/",
        },
      ],
      hardwareSystem: "",
      proSystemList: [],
      provisioningId: 0,
      itemClass: "",
      itemClassList: [],
      itemClassId: 0,
      hardwareById: {},
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {},
  methods: {
    selectedHardware(off) {
      this.hardwareById.provisioning.map((e) => {
        if (e.systemname == off) {
          this.provisioningId = e.id;
        }
      });
    },
    selectedItemClass(off) {
      this.hardwareById.itemClassData.map((e) => {
        if (e.type == off) {
          this.itemClassId = e.id;
        }
      });
    },
    async editHardwareDataById() {
      try {
        const response = await this.$store.dispatch(
          "provisioningConfig/seteditHardwareMappingData",
          this.$route.params.id
        );
        this.hardwareById = response.data;
        this.hardwareSystem = this.hardwareById.provisioningValue;
        this.itemClass = this.hardwareById.itemClassName;
        this.provisioningId = parseInt(this.hardwareById.provisioningId);
        this.itemClassId = parseInt(this.hardwareById.itemClass);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateHardwarePlan() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        itemClass: this.itemClassId,
        provisioningId: this.provisioningId,
      };
      await this.$store.dispatch(
        "provisioningConfig/updateHardwareMappingAction",
        { id: this.$route.params.id, data: payload }
      );
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Provisioning Device Edited Successfully!",
        type: "success",
      });
      this.$router.push("/provisioningDevice");
    },
    cancel() {
      this.$router.push("/provisioningDevice");
    },
  },
  watch: {
    hardwareById(val) {
      for (let role of val.provisioning) {
        this.proSystemList.push(role.systemname);
      }
      for (let role of val.itemClassData) {
        this.itemClassList.push(role.type);
      }
    },
  },
  mounted() {
    this.editHardwareDataById();
  },
};
</script>
